<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>Område</th>
          <th class="text-center" v-if="windowWidth > 600">Kommentar</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, index) in value">
          <tr :class="item.active ? 'active' : 'inactive'" :key="index + '1'">
            <td>
              <v-switch
                color="primary"
                v-model="item.active"
                label
                @change="updateActive(item)"
              ></v-switch>
            </td>
            <td class="objectTitle">{{ item.title }}</td>
            <td class="text-center" v-if="windowWidth > 600">
              <v-text-field
                solo
                hide-details
                label="Kommentar"
                :disabled="item.active ? false : true"
                clearable
                v-model="item.comment"
                @input="updateMessage"
              ></v-text-field>
            </td>
          </tr>
          <tr
            :class="item.active ? 'active' : 'inactive'"
            class="no-margin"
            v-if="windowWidth <= 600"
            :key="index + '2'"
          >
            <td colspan="3">
              <small>Kommentar</small>
              <v-text-field
                solo
                label="Kommentar"
                :disabled="item.active ? false : true"
                clearable
                v-model="item.comment"
                @input="updateMessage"
              ></v-text-field>
            </td>
          </tr>
          <tr :key="index + '3'">
            <td colspan="3">
              <v-divider></v-divider>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="text-right">
      <v-btn color="primary" flat @click="newDialog = true" class="mb-4 mt-2"
        >Legg til område</v-btn
      >
    </div>
    <v-dialog v-model="newDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Nytt område</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Område"
            clearable
            v-model="newObject.title"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="newDialog = false">Avbryt</v-btn>
          <v-btn color="primary" flat @click="createNewObject">Lagre</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
export default {
  props: ["value"],
  data() {
    return {
      id: null,
      newDialog: false,
      newObject: { title: "", value: null, active: true, comment: null },
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.id = this._uid;
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  methods: {
    updateMessage: function () {
      this.$emit("update-fields");
    },
    updateActive(item) {
      this.$emit("update-fields");
    },
    updateNumber(item) {
      this.$emit("update-fields");
    },
    openNewDialog() {
      this.newDialog = true;
    },
    createNewObject() {
      this.value.push(this.newObject);
      this.newObject = { title: "", active: true };
      this.newDialog = false;
      this.$emit("update-fields");
    },
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table td,
table th {
  padding: 3px;
  font-size: 1rem;
}
table tr.inactive {
  background-color: lightgrey;
}
table tr.inactive .objectTitle {
  text-decoration: line-through;
}
table .radio {
  font-size: 2rem;
}
hr {
  margin-top: 0;
  margin-bottom: 0;
}
</style>